import React from "react";
import { Button, lighten } from "@material-ui/core";
import CartIcon from "@material-ui/icons/ShoppingCart";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from '@material-ui/core/Tooltip';

import { Context as CartContext } from "../../context/cart.context";
import ControlMessage from "./ControlMessage";
import PaymentOptions from "./PaymentOptions";

const AddToCart = (props) => {
  const { state, addToCart, removeFromCart } = React.useContext(CartContext);
  const { cartItem } = props;
  const [inCart, setInCart] = React.useState(false);
  const [controlMessageOpen, setControlMessageOpen] = React.useState(false);
  const [paymentOptionsOpen, setPaymentOptionsOpen] = React.useState(false);

  
  const [controlMessage, setControlMessage] = React.useState('');
  const [controlOrder, setControlOrder] = React.useState('');
  
  // const [disabledCart, setDisabledCart] = React.useState(false);

  React.useEffect(() => {
    setButton();
  });

  const setButton = () => {
    const result = state.shoppingCart.find(
      ({ invoiceID }) => invoiceID === cartItem.invoiceID
    );
    setInCart(result ? true : false);
  };

  const cartContainsNewestInvoice = (arr, target) => {
    return target.every(v => arr.includes(v));
  } 

  // const cartInvoicesPaidInFull = (arr, target) => {
  //   return target.every(v => arr.includes(v));
  // } 

  const disableAddToCartButton = () => {
    // control order logic :
		// 	-1 = display only
		// 	0 = Green Light to process
		// 	1 = Good to process but another invoice is depenent on it being paid first
		// 	2-Infinity = requeires all the lower numbers to be paid first. Or have them in the shopping cart to be paid at the same time.

    if(cartItem.controlOrder == -1){
      return true;
    }

    if(cartItem.controlOrder == 0 || cartItem.controlOrder == 1){
      return false;
    }

    var invoiceIdsInCart = [];
    state.shoppingCart.forEach(element => {
      //Insure that the full balance was added and just not payment option.
      if(element.finalBalanceCheck >= element.balance){
        invoiceIdsInCart.push(element.invoiceID)
      }
    });

    if(cartContainsNewestInvoice(invoiceIdsInCart, cartItem.controlInvoicesRequiredFirst)){
      return false;
    }

    return true;
  }


  return (
    <>
      {/* <Tooltip title={cartItem.controlMessage}> */}
        <Button
          variant="contained"
          style={{
            background: disableAddToCartButton() ? "#e0e0e0" : (inCart ? "#DB565E" : "#5AA869"),
            height: 30,
            borderRadius: 6,
            color: disableAddToCartButton() ? "black" : "white",
          }}
          startIcon={inCart ? <DeleteIcon /> : <CartIcon />}
          // disabled={disableAddToCartButton(cartItem)}
          onClick={() => {
            if(!disableAddToCartButton(cartItem)){
              if(inCart){
                removeFromCart({
                  cartItem: cartItem,
                  cart: state.shoppingCart,
                })
              } else {
                if(typeof cartItem.paymentOptions !== null && cartItem.paymentOptions && cartItem.paymentOptions.length >= 1){
                  setPaymentOptionsOpen(true);
                } else {
                  addToCart(cartItem);
                }
              }
              // inCart
              // ? removeFromCart({
              //     cartItem: cartItem,
              //     cart: state.shoppingCart,
              //   })
              // : addToCart(cartItem);
            } else {
              setControlMessage(cartItem.controlMessage)
              setControlOrder(cartItem.controlOrder)
              setControlMessageOpen(true)
            }
          }}
        >
          {inCart ? "Remove" : (typeof cartItem.paymentOptions !== null && cartItem.paymentOptions && cartItem.paymentOptions.length >= 1 ? "Options" :"Add")}
        </Button>
      {/* </Tooltip> */}
      <ControlMessage
				modalOpen={controlMessageOpen}
        controlMessage={controlMessage}
        controlOrder={controlOrder}
				setModalOpen={setControlMessageOpen}
			/>

      <PaymentOptions
				modalOpen={paymentOptionsOpen}
        cartItem={cartItem}
				setModalOpen={setPaymentOptionsOpen}
			/>
    </>
  );
};

export default AddToCart;
